import { apiFetch } from "./api";
import { ClientPlacementListResponse, ClientPlacementDetailResponse } from "../types/fyo";

export interface ClientPlacementFilters {
  status?:          string;
  name?:            string;
  window_expired?:  boolean;
  limit?:           number;
  offset?:          number;
}

export function fetchClientPlacementDetail(rms_candidate_id: number | string): Promise<ClientPlacementDetailResponse> {
  return apiFetch(`/client-placements/${rms_candidate_id}`);
}

export function fetchClientPlacements(filters: ClientPlacementFilters = {}): Promise<ClientPlacementListResponse> {
  const q = new URLSearchParams();
  if (filters.status)                 q.set("status",         filters.status);
  if (filters.name)                   q.set("name",           filters.name);
  if (filters.window_expired != null) q.set("window_expired", String(filters.window_expired));
  q.set("limit",  String(filters.limit  ?? 50));
  q.set("offset", String(filters.offset ?? 0));
  return apiFetch(`/client-placements?${q}`);
}
